<template>
  <div
    class="layout_row layrow"
    :id="'u' + row.widgets_id"
    :data-id="row.widgets_id"
    :body_system_row="row.data.body_system_row"
    :anchor-id="row.data.anchor_id"
    :style="{...rowBackgroundStyle}"
    :data-index="row_index"
    @mouseenter="
      (e) => {
        edit_show(e, true);
      }
    "
    @mouseleave="
      (e) => {
        edit_show(e, false);
      }
    "
    :rowType="row.rowType"
    :data-type="row.data.is_system == 'true' ? 'system' : 'custom'"
    name="layout_row"
    :class="[getClassList(),row.data.pc_infor && row.data.pc_infor.fixed_background_isOpen == 'true' ? 'fixed_row_background_show' : '']"
    @contextmenu="row_contextmenu"
  >
    <div class="coverLayrow" v-if="material_tag"></div>

    <!--系统栏目,顶部固定-->
    <fixed_background_layer
      v-if="
        $store.state.myRender.common.fixed_height === 'system' &&
        row.data.is_system == 'true'
      "
    ></fixed_background_layer>

    <!--设置loybox 上下左右padding(pc独有)-->
    <div class="padding_edit_block" v-if="isEdit"></div>

    <div class="hover_border_top" v-if="isHover"></div>
    <div class="hover_border_left" v-if="isHover"></div>
    <div class="hover_border_right" v-if="isHover"></div>
    <div class="hover_border_bottom" v-if="isHover"></div>

    <!--编辑框(pc独有) v-if="edit_isShow"-->
    <template v-if="$store.state.app.view_pattern === 'pc'">
      <div
        class="row_edit_frame"
        v-if="edit_isShow"
        :class="
          row.rowType === 'header' && row_index === 0
            ? 'row_edit_frame_first'
            : ''
        "
        :style="editBtnStyle"
      >
        <div class="row_edit">
          <p @click="edit_row" v-if="row.data.body_system_row != 'true'">
            {{ editLabel }}
          </p>
          <i class="separator"></i>

          <p @click="edit_row" v-if="row.data.body_system_row === 'true'">{{$t('widgets_layout_row_index_2958')}}</p>
          <div class="set" @click="row_edit" v-else>
            <el-tooltip
              class="item"
              effect="light"
              :content="$t('widgets_basic_footnav_edit_567')"
              placement="top"
            >
              <i class="back"></i>
            </el-tooltip>
          </div>

          <div class="set" @click="onClickAddRowBtn">
            <el-tooltip
              class="item"
              effect="light"
              :content="addLabel"
              placement="top"
            >
              <i class="add"></i>
            </el-tooltip>
          </div>

          <template v-if="row.data.body_system_row != 'true'">
            <div class="set" @click="to_after">
              <el-tooltip
                class="item"
                effect="light"
                :content="$t('widgets_layout_row_index_2959')"
                placement="top"
              >
                <i class="after" :class="row_index === 0 
                || basic_loginregister_bottom_row ? 'disabled' : ''"></i>
              </el-tooltip>
            </div>
            <div class="set" @click="to_befor">
              <el-tooltip
                class="item"
                effect="light"
                :content="$t('widgets_layout_row_index_2960')"
                placement="top"
              >
                <i
                  class="before"
                  :class="
                    (row_index === $store.state.myRender[row.rowType].length - 1)
                    ||row_has_basic_loginregister
                      ? 'disabled'
                      : ''
                  "
                ></i>
              </el-tooltip>
            </div>
          </template>
          <!-- 登录注册组件 不要删除按钮 加一个眼睛隐藏 -->
          <div class="set" v-if="row_has_basic_loginregister" @click="login_register_hidden">
            <el-tooltip
              class="item"
              effect="light"
              :content="$t('components_my_mb_edit_index_2366')"
              placement="top"
              transition="none"
            >
              <span class="close-view el-icon-view"></span>
            </el-tooltip>
            <!--  <span class="el-icon-view"></span> -->
          </div>
          <div class="set" v-else @click="del_row">
            <el-tooltip
              class="item"
              effect="light"
              :content="$t('widgets_layout_row_index_2961')"
              placement="top"
              transition="none"
              :disabled="
                row.data.is_system == 'true' || has_system_module ? true : false
              "
            >
              <i
                class="close"
                :class="
                  row.data.is_system == 'true' || has_system_module
                    ? 'disabled'
                    : ''
                "
              ></i>
            </el-tooltip>
          </div>

          <!-- 部分页面独有挂件 -->
          <template v-if="row.data.body_system_row === 'true'">
            <div
              class="set"
              @click="close_sys_col"
              v-if="row.children.length == 2"
            >
              <el-tooltip
                class="item"
                effect="light"
                :content="$t('widgets_layout_row_index_2962')"
                placement="top"
                transition="none"
              >
                <i class="icon-close-col close_col"></i>
              </el-tooltip>
            </div>

            <div
              class="set"
              @click="open_sys_col"
              v-if="row.children.length == 1"
            >
              <el-tooltip
                class="item"
                effect="light"
                :content="$t('widgets_layout_row_index_2963')"
                placement="top"
                transition="none"
              >
                <i class="icon-open-col open_col"></i>
              </el-tooltip>
            </div>
          </template>
        </div>
      </div>
    </template>

    <!--编辑框(pc独有)-->
    <template v-if="$store.state.app.view_pattern === 'pc'">
      <div
        class="row_edit_frame row_edit_center"
        v-if="
          edit_isShow && (row.rowType === 'header' || row.rowType === 'footer')
        "
        :class="
          row.rowType === 'header' && row_index === 0
            ? 'row_edit_frame_first'
            : ''
        "
      >
        <div class="row_edit">
          <p v-if="row.rowType === 'header'" @click="edit_header">{{$t('widgets_layout_row_index_2964')}}</p>
          <p v-if="row.rowType === 'footer'" @click="edit_footer">{{$t('widgets_layout_row_index_2965')}}</p>
        </div>
      </div>
    </template>

    <!--编辑列(pc独有)-->
    <!-- <template v-if="$store.state.app.view_pattern === 'pc'">
      <div
        class="row_edit_frame"
        v-if="isEdit"
        :class="row.rowType === 'header' && row_index == 0 ? 'row_edit_frame_first' : ''"
      >
        <div class="row_edit">
          <p class="col" @click="templet.add_col(row)">添加列</p>
          <i class="separator"></i>
          <p class="quit" @click="edit_out">退出编辑</p>
        </div>
      </div>
    </template> -->

    <!--通栏是否显示，mb独有-->
    <template v-if="$store.state.app.view_pattern === 'mb'">
      <div
        class="jz_web_row_hide_tip"
        v-if="
          $store.state.mb_row_isShow.row_btn_isShow &&
          row.data.mb_infor.isShow == false
        "
      >
        <button class="jz_button jz_button__active" @click="mb_row_show">
          <span class="jz_button_content">{{$t('widgets_layout_row_index_2966')}}</span>
        </button>
      </div>
    </template>

    <del_row
      v-if="is_del_row"
      @dialog_close="row_dialog_close"
      :index="row_index"
      :rowType="row.rowType"
      :row="row"
    ></del_row>
    <template v-if="$store.state.app.view_pattern === 'pc'">
      <div
        class="resize_left resize_btn"
        :style="resizeLeftStyle"
        v-if="isEdit"
      >
        <div
          class="tips_top_left my_tips my_tips_style"
          :style="{
            left: row.data[$store.state.app.view_pattern + '_infor']
              .box_paddingLeft,
          }"
        ></div>
      </div>
      <div
        class="resize_right resize_btn"
        :style="resizeRightStyle"
        v-if="isEdit"
      >
        <div
          class="tips_top_right my_tips my_tips_style"
          :style="{
            right:
              row.data[$store.state.app.view_pattern + '_infor']
                .box_paddingRight,
          }"
        ></div>
      </div>

      <div class="resize_top resize_btn" v-if="isEdit">
        <div class="tips_top my_tips my_tips_style"></div>
      </div>
      <div class="resize_bottom resize_btn" v-if="isEdit">
        <div class="tips_bottom my_tips my_tips_style"></div>
      </div>
    </template>
    <div
      class="laybox"
      :style="{
        paddingLeft:
          row.data[$store.state.app.view_pattern + '_infor'].box_paddingLeft,
        paddingRight:
          row.data[$store.state.app.view_pattern + '_infor'].box_paddingRight,
        paddingTop:
          row.data[$store.state.app.view_pattern + '_infor'].box_paddingTop,
        paddingBottom:
          row.data[$store.state.app.view_pattern + '_infor'].box_paddingBottom,
          ...widthStyle,
          ...contentBackgroundStyle,
          position: 'relative'
      }"
    >
      <div
        class="laybox_child_frame"
        :class="
          $store.state.app.view_pattern === 'mb' ? 'mb_laybox_child_frame' : ''
        "
      >
        <template v-if="isEdit && $store.state.app.view_pattern === 'pc'">
          <div class="hover_border_top" v-if="isHover"></div>
          <div class="hover_border_left" v-if="isHover"></div>
          <div class="hover_border_right" v-if="isHover"></div>
          <div class="hover_border_bottom" v-if="isHover"></div>
        </template>

        <template v-for="(column, i) in row.children">
          <layout_column_new
            v-if="column.isNewCol"
            :column="column"
            :row="row"
            :col_index="i"
            :material_tag="material_tag"
            :key="column.widgets_id"
            :col_order_val="row.data.col_order_val"
          ></layout_column_new>
          <layout_column
            v-else
            :column="column"
            :row="row"
            :col_index="i"
            :material_tag="material_tag"
            :key="column.widgets_id"
            :col_order_val="row.data.col_order_val"
          ></layout_column>
        </template>


        <div
          class="vip_logo"
          v-if="
            $store.state.vip.switch &&
            row.rowType === 'header' &&
            $store.state.myRender.common.vip_type === 'default' &&
            row.data.is_system &&!row_has_basic_loginregister
          "
        >
          <!-- 添加了&&!row_has_basic_loginregister 登录注册的系统通栏不显示  -->

          <img
            :src="`https://staticjs.71360.com/3/static/image/${$store.state.vip.level}_years.png`"
          />
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import i18n from '../../language/index'

import layout_column from "../layout_column/index";
import layout_column_new from "../layout_column_new/index";
import del_row from "@/components/del_row";
import fixed_background_layer from "@/components/fixed_background_layer";
import Col from "@/base/one_column";
import {get_anchor, save_anchor, deleteNav} from "@/api/app";

export default {
  name: "layout_row",
  props: {
    row: {
      type: Object,
      default: null,
    },
    row_index: {
      type: Number,
      default: 0,
    },
    material_tag: {
      type: Boolean,
      defaults: false,
    },
  },
  data() {
    return {
      edit_isShow: false,
      isHover: false,
      timer: null,
      is_del_row: false,
      anchor_data: [], //锚点数据,
      navList: [], //导航栏数据
    };
  },
  computed: {
    isPC() {
      return this.$store.state.app.view_pattern === "pc";
    },
    infor() {
      return this.row.data[this.$store.state.app.view_pattern + "_infor"];
    },
    module() {
      return this.$store.state.app.module_Data;
    },
    isEdit() {
      return this.templet.row_is_edit(this.row);
    },
    has_system_module() {
      return this.templet.has_system_module(this.row);
    },
    col_list() {
      const cols = this.row.children;
      const orders = this.row.data.col_order_array;
      if (
        this.$store.state.app.view_pattern === "mb" &&
        this.row.data.col_order_val === "custom"
      ) {
        //如果选的是自定义，需要根据列排序重新排一下
        const new_cols = this.templet.col_orders_create(orders, cols);
        return new_cols;
      } else {
        return cols;
      }
    },
    isCurrent() {
      if (this.$store.state.myRender.private.banner_isShow) {
        return (
          this.row_index === this.$store.state.app.fullPageCurrentIndex - 1 &&
          this.row.rowType === "body"
        );
      } else {
        return (
          this.row_index === this.$store.state.app.fullPageCurrentIndex &&
          this.row.rowType === "body"
        );
      }
    },
    isFullPage() {
      return this.$store.state.app.scrollType !== "normal";
    },
    editLabel() {
      return this.isFullPage && this.row.rowType === "body" && this.isPC
        ? i18n.t('widgets_layout_row_edit_2974')
        : i18n.t('widgets_layout_row_edit_2949');
    },
    addLabel() {
      return this.isFullPage && this.row.rowType === "body" && this.isPC
        ? i18n.t('widgets_layout_row_index_2975')
        : i18n.t('widgets_layout_row_index_2967');
    },
    editBtnStyle() {
      if (this.isFullPage) {
        if (this.row.rowType === "header") {
          return {}
        }
        if (this.row.rowType === "footer") {
          return {}
        }
        let headerIsShow =
          String(this.$store.state.myRender.common.header_display) === "true";
        let headerIsXuanfu =
          this.$store.state.myRender.private.fullPageTopNavType === "xuanfu";
        let headerIsFixed =
          String(this.$store.state.myRender.common.fixed_header) === "true";
        let fullPageCurrentIndex = this.$store.state.app.fullPageCurrentIndex;
        if (
          headerIsShow &&
          headerIsXuanfu &&
          (headerIsFixed || fullPageCurrentIndex == 0)
        ) {
          return {
            top: $(".myheader").height() + 10 + "px!important",
          };
        } else {
          return {
            top: "20px!important",
          };
        }
      } else {
        return {};
      }
    },
    background_image() {
      //debugger
      let data = '';
      const infor = this.row.data[this.$store.state.app.view_pattern + "_infor"];
      if (infor.row_background_set.radio_val == 'hidden') {
        data = 'none';
      } else {
        const background = infor.row_background_set[infor.row_background_set.radio_val];
        if (background.img != '') {
          data = `url(${background.img})`;
        }
        if (background.pattern === 'linear_gradient') {
          const url = data ? data + ',' : '';
          //渐变
          data = `${url}linear-gradient(${background.linear_gradient.deg}deg,${background.linear_gradient.start_color}${background.linear_gradient.start_pointer}%,${background.linear_gradient.end_color}${background.linear_gradient.end_pointer}%)`;
        }

      }
      return data
    },
    basic_loginregister_bottom_row() { // 上移通栏 登录注册组件通栏 下面的row不能上移
      let basic_loginregister = this.templet.use_name_find_module("header", 'basic_loginregister');
      return this.row.rowType === 'header' && this.row_index == 1 && basic_loginregister
    },
    row_has_basic_loginregister() { // 通栏登录注册 头部通栏 如果 不存在添加登录注册的话 隐藏这一个系统通栏 row 含有登录注册组件不能下移
      return this.row.rowType === 'header' && this.templet.row_has_module(this.row, 'basic_loginregister')
    },
    widthStyle() {
      if (this.$store.state.myRender.common.adaptWidth.isOpen === 'true' && this.row.data.pc_infor.contentWidthType === 'adapt') {
        return {
          'maxWidth': this.$store.state.myRender.common.adaptWidth.val + 'px'
        }
      } else {
        return {}
      }
    },
    rowBackgroundStyle() {
      if (this.$store.state.myRender.common.adaptWidth.isOpen === 'true' && this.row.data.pc_infor.contentWidthType === 'adapt' && this.row.data.pc_infor.adaptBackgroundIsOpen === 'true') {
        return {}
      } else {
        return this.backgroundStyle
      }
    },
    contentBackgroundStyle() {
      if (this.$store.state.myRender.common.adaptWidth.isOpen === 'true' && this.row.data.pc_infor.contentWidthType === 'adapt' && this.row.data.pc_infor.adaptBackgroundIsOpen === 'true') {
        return this.backgroundStyle
      } else {
        return {}
      }
    },
    backgroundStyle() {
      let infor = this.infor
      return {
        backgroundColor: infor.row_background_set.radio_val !== 'hidden'
          ? infor.row_background_set[infor.row_background_set.radio_val].color
          : '',
        borderColor:
          infor.row_border_set.radio_val !== 'hidden'
            ? infor.row_border_set[infor.row_border_set.radio_val].border_color
            : '',
        borderStyle:
          infor.row_border_set.radio_val !== 'hidden'
            ? infor.row_border_set[infor.row_border_set.radio_val].border_style
            : '',
        borderLeftWidth:
          infor.row_border_set.radio_val !== 'hidden'
            ? infor.row_border_set[infor.row_border_set.radio_val]
            .border_left_width + 'px'
            : '',
        borderRightWidth:
          infor.row_border_set.radio_val !== 'hidden'
            ? infor.row_border_set[infor.row_border_set.radio_val]
            .border_right_width + 'px'
            : '',
        borderTopWidth:
          infor.row_border_set.radio_val !== 'hidden'
            ? infor.row_border_set[infor.row_border_set.radio_val]
            .border_top_width + 'px'
            : '',
        borderBottomWidth:
          infor.row_border_set.radio_val !== 'hidden'
            ? infor.row_border_set[infor.row_border_set.radio_val]
            .border_bottom_width + 'px'
            : '',
        backgroundImage: this.background_image,
        boxShadow:
          infor.row_is_shadow == 'true'
            ? 'rgba(0, 0, 0, 0.15) 0px 0px 12px 0px'
            : '0 0 0 #fff',
        backgroundSize:
          infor.row_background_set.radio_val !== 'hidden'
            ? infor.row_background_set[infor.row_background_set.radio_val]
              .background_size
            : 'auto',
        backgroundRepeat:
          infor.row_background_set.radio_val !== 'hidden'
            ? infor.row_background_set[infor.row_background_set.radio_val]
              .background_repeat
            : 'repeat',
        backgroundPosition:
          infor.row_background_set.radio_val !== 'hidden'
            ? infor.row_background_set[infor.row_background_set.radio_val]
              .background_position
            : '0% 0%',
      }
    },
    resizeLeftStyle() {
      return {
        left: `calc(${this.row.data[this.$store.state.app.view_pattern + '_infor'].box_paddingLeft} + ${$('#u' + this.row.widgets_id).find('.laybox').offset().left}px)`
      }
    },
    resizeRightStyle() {
      return {
        right: `calc(${this.row.data[this.$store.state.app.view_pattern + '_infor'].box_paddingRight} + ${$('#u' + this.row.widgets_id).find('.laybox').offset().left}px)`
      }
    },
  },
  components: {
    layout_column,
    layout_column_new,
    fixed_background_layer,
    del_row,
  },
  watch: {
    "row.data.col_order_array": {
      handler: function (val, oldVal) {
        //根据row下面的col_order_array，将每个col中的order重新生成
        val.map((o_val, i) => {
          this.row.children.map((c_val) => {
            if (o_val === c_val.data.col_id) {
              c_val.data.mb_infor.order = i;
            }
          });
        });
      },
      deep: true,
    },
  },
  methods: {
    edit_show(e, val) {
      this.isHover = val;
      if (this.$store.state.app.view_pattern === "pc") {
        this.pc_edit_isShow(val);
      } else {
        this.mb_edit_isShow(e, val);
      }
    },
    //mb模式下编辑框逻辑
    mb_edit_isShow(e, val) {
      //隐藏状态下，不触发鼠标悬浮逻辑
      if (this.row.data.mb_infor.isShow == false) {
        return;
      }

      if (val) {
        //门牌显示出来
        this.templet.mb_edit_show(e, this);
      } else {
        //门牌隐藏
        this.templet.mb_edit_hidden();
      }
    },

    // mb_edit_show(e) {
    //   this.$store.commit("row/Reset_mb_edit");
    //   const l = $(window).width() / 2 + 375 / 2 + 10;
    //   let t = $(e.target).offset().top;
    //   if (t < 140) {
    //     t = 180;
    //   }
    //   this.$store.state.row.mb_edit.left = l;
    //   this.$store.state.row.mb_edit.top = t;
    //   this.$store.state.row.mb_edit.isShow = true;
    //   this.$store.state.row.mb_edit.select_row = this.row;
    // },

    // mb_edit_hidden() {
    //   if (this.$store.state.row.mb_edit.timer == null) {
    //     this.$store.state.row.mb_edit.timer = setTimeout(() => {
    //       this.$store.commit("row/Reset_mb_edit");
    //     }, 300);
    //   }
    // },

    //pc模式下编辑框逻辑
    pc_edit_isShow(val) {
      if (!this.isEdit) {
        this.edit_isShow = val;
      } else {
        this.edit_isShow = false;
      }
    },

    edit_row(e) {
      //this.row.isEdit = true;
      this.templet.dialog_close();

      //改变顶部固定层级
      //this.set_fixed_header_index(e);
      if ($(e.target).parents(".layout_header_fixed").length > 0) {
        $("html").addClass("fixed_header_to_top");
        $(window).scrollTop(0);
      }

      this.$store.commit("row/SET_edit_mongolia", true);

      this.$store.commit("left_sidebar/set_dialog", false);

      //编辑不能直接改变挂件状态，不然会被插入到历史记录
      this.$store.commit("row/SET_click_edit_row_btn", this.row);
      this.templet.edit_row_set_sort(true); //当前编辑row，设置拖拽排序
      this.$store.commit("app/SET_module_Data", this.row);

      this.$store.commit("main_dialog/Change_main_dialog_isShow", true);
      this.$store.commit("main_dialog/Change_edit_name", this.row.name);
      this.$store.commit("main_dialog/Change_tabs_name", "col");
      this.$nextTick(() => {
        $("html").removeClass("fixed_header_to_top");
        //计算蒙层
        this.templet.calculation_mongolia(this.row);
        this.templet.col_width_change(this.row);
        this.templet.laybox_sizeChange_rl(this.row, "left");
        this.templet.laybox_sizeChange_rl(this.row, "right");
        this.templet.laybox_sizeChange_top(this.row);
        this.templet.laybox_sizeChange_bottom(this.row);
      });
    },

    set_fixed_header_index(e) {
      const is_header = $(e.target).parents(".layout_header");

      //如果点击的是头部里的编辑
      if (is_header.length > 0) {
        const is_fixed = is_header.hasClass("layout_header_fixed");
        if (is_fixed) {
          //如果再顶部已固定的情况下
          //打开内部蒙层
          $(".fixed_header_mongolia").css("display", "block");

          //整体层级要高于外部
          is_header.addClass("fixed_header_edit");
        } else {
          $(".fixed_header_mongolia").css("display", "none");
          is_header.removeClass("fixed_header_edit");
        }
      } else {
        //不是头部里的按钮
        $(".fixed_header_mongolia").css("display", "none");
        is_header.removeClass("fixed_header_edit");
      }
    },
    row_edit() {
      this.$store.commit("app/SET_module_Data", this.row);
      this.$store.commit("main_dialog/Change_main_dialog_isShow", true);
      this.$store.commit("main_dialog/Change_edit_name", this.row.name);
      this.$store.commit("main_dialog/Change_tabs_name", "row");
    },
    edit_out() {
      this.templet.row_edit_close();
    },
    to_befor() {
      const list = this.$store.state.myRender[this.row.rowType];
      if (this.row_index == list.length - 1) {
        // this.$message.error(
        //   `当前是${
        //     this.row.rowType === "header"
        //       ? "头部"
        //       : this.row.rowType === "body"
        //       ? "中部"
        //       : "底部"
        //   }最后一个通栏，无法再往下移动！`
        // );
        return;
      }
      const befor_index = this.row_index + 1;
      const now_obj = list.splice(this.row_index, 1)[0];
      const row_id = this.row.widgets_id;

      list.splice(befor_index, 0, now_obj);
      if (!this.isFullPage) {
        this.setTimeout_row_scroll(row_id);
      }
      window.fullPage && window.fullPage.handleSlideSortDown();
    },
    to_after() {
      const list = this.$store.state.myRender[this.row.rowType];
      if (this.row_index == 0) {
        // this.$message.error(
        //   `当前是${
        //     this.row.rowType === "header"
        //       ? "头部"
        //       : this.row.rowType === "body"
        //       ? "中部"
        //       : "底部"
        //   }第一个通栏，无法再往上移动！`
        // );
        return;
      }
      const row_id = this.row.widgets_id;

      const after_index = this.row_index - 1;
      const now_obj = list.splice(this.row_index, 1)[0];
      list.splice(after_index, 0, now_obj);
      this.setTimeout_row_scroll(row_id);

      window.fullPage && window.fullPage.handleSlideSortUp();
    },

    setTimeout_row_scroll(row_id) {
      if (this.timer == null) {
        this.timer = setTimeout(() => {
          clearTimeout(this.timer);
          this.timer = null;
          this.templet.row_scroll(row_id);
        }, 300);
      }
    },
    row_dialog_close() {
      this.is_del_row = false;
    },
    del_row() {
      this.templet.dialog_close();
      const rowType = this.row.rowType;
      const list = this.$store.state.myRender[rowType];

      //如果只剩下一个
      if (list.length == 1) {
        this.$message.error(
          // `当前是${
          //   rowType === "header" ? "头部" : rowType === "body" ? "中部" : i18n.t('view_left_sidebar_page_setting_page_setting_275')
          // }必须存在一个通栏！`
          i18n.t('widgets_layout_row_index_2977', [ rowType === "header" ? i18n.t('base_kindeditor_all_2976') : owType === "body" ? i18n.t('base_kindeditor_all_1631') : i18n.t('view_left_sidebar_page_setting_page_setting_275')])
        );
        return;
      }

      //系统行不能删除
      if (this.row.data.is_system == "true") {
        this.$message.error({
          showClose: true,
          message: i18n.t('widgets_layout_row_index_2968'),
        });
        return;
      }

      if (this.has_system_module) {
        this.$message.error({
          showClose: true,
          message: i18n.t('widgets_layout_row_edit_2956'),
        });
        return;
      }

      //如果是关联挂件，删除需要有确认提示
      if (this.row.theme_eare_name != "") {
        this.is_del_row = true;
      } else {
        //添加删除通栏时清除通栏下锚点数据的逻辑
        let anchor_list = [];
        if (this.row.data && this.row.data.anchor_id) {
          anchor_list.push(this.row.data.anchor_id);
        }
        this.row.children.map((e) => {
          if (e.data && e.data.anchor_id) {
            anchor_list.push(e.data.anchor_id);
          }
          if (e.children && e.children instanceof Array) {
            e.children.map((x) => {
              if (x.data && x.data.anchor_id) {
                anchor_list.push(x.data.anchor_id);
              }
              if (x.children && x.children instanceof Array) {
                x.children.map((y) => {
                  if (y.data && y.data.anchor_id) {
                    anchor_list.push(y.data.anchor_id);
                  }
                });
              }
              //如果包含了H1，则开关关闭
              if (x.name == "basic_h1") {
                this.$store.state.myRender.private.H1_isOpen = false;
              }
            });
          }
        });

        let that = this;
        if (anchor_list.length != 0) {
          this.$confirm(
            i18n.t('widgets_layout_row_index_2969'),
            i18n.t('view_public_topbar_23'),
            {
              confirmButtonText: i18n.t('view_public_topbar_24'),
              cancelButtonText: i18n.t('view_public_topbar_11'),
              type: "warning",
              customClass: 'language_confirm_' + this.$store.state.app.web_language_wm
            }
          )
            .then(() => {
              that.get_anchorAll(anchor_list);
              list.splice(that.row_index, 1);
            })
            .catch(() => {
              that.$message({
                type: "info",
                message: i18n.t('base_row_y _ 副本_1934'),
              });
            });
        } else {
          list.splice(this.row_index, 1);
        }
      }

      window.fullPage &&
      fullPage.removeSlide(
        this.$store.state.app.fullPageCurrentIndex,
        this.row
      );
    },
    clearAnchor(anchorList) {
    },
    get_anchorAll(anchor_list = []) {
      get_anchor()
        .then((res) => {
          if (res.code === 200) {
            this.anchor_data = res.data;
            let navList = [];
            anchor_list.map((id) => {
              for (let i in this.anchor_data) {
                if (this.anchor_data[i] instanceof Array) {
                  this.anchor_data[i] = this.anchor_data[i].filter((item) => {
                    if (item.id == id && navList.indexOf(item.navID) == -1) {
                      navList.push(item.navID);
                    }
                    return item.id != id;
                  });
                }
              }
            });
            this.navList = navList;
            this.$store.commit("anchor/SET_allAnchorList", this.anchor_data);
          }
        })
        .catch((error) => {
          this.$message.error(error);
        })
        .finally(() => {
          this.save_anchorAll();
          if (navList.length != 0) {
            this.deleteNav(this.navList.join(","));
          } else {
            // this.templet.p_save()
          }
        });
    },
    save_anchorAll() {
      let data = {
        anchor: this.anchor_data,
      };
      let that = this;
      save_anchor(data)
        .then((res) => {
          if (res.code == 200) {
            console.log("锚点数据更新保存成功");
          }
        })
        .catch((error) => {
          this.$message.error(error);
        });
    },
    //删除锚点导航
    deleteNav(navID, fn) {
      let that = this;
      deleteNav({
        id: navID,
        type: "anchor",
      })
        .then((res) => {
          if (res.code === 200) {
            // this.$message.success('删除导航成功');
            that.$store.state.myRender.common.setting.headerNavRadio = false;
            this.$nextTick(() => {
              that.$store.state.myRender.common.setting.headerNavRadio = true;
            });
            // that.templet.p_save()
          } else {
            this.$message.error(res.message);
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },
    row_contextmenu(e) {
      if ($(this.$el).parents('.material-wrapper').length) {
        return
      }
      if (this.templet.is_contextmenu(this.row)) {
        e.preventDefault();
        this.$store.commit("row_contextmenu_dialog/SET_type", "row");
        this.$store.commit("row_contextmenu_dialog/SET_isShow", true);

        this.$store.commit(
          "row_contextmenu_dialog/SET_contextmenu_obj",
          this.row
        );
        this.$nextTick(() => {
          this.$store.commit(
            "row_contextmenu_dialog/SET_top",
            this.templet.contextmenu_position(e).y
          );
          this.$store.commit(
            "row_contextmenu_dialog/SET_left",
            this.templet.contextmenu_position(e).x
          );
        });
      }
    },

    mb_row_show() {
      this.row.data.mb_infor.isShow = true;
      this.templet.mb_eye_isShow();
    },
    edit_header() {
      this.$store.commit("left_sidebar/set_dialog", true);
      this.$store.commit("left_sidebar/set_active", "style");
      this.$store.commit("left_sidebar/set_style_active", "header");
    },
    edit_footer() {
      this.$store.commit("left_sidebar/set_dialog", true);
      this.$store.commit("left_sidebar/set_active", "style");
      this.$store.commit("left_sidebar/set_style_active", "footer");
    },
    close_sys_col() {
      if (this.row.children.length == 2) {
        this.row.children[1].data.pc_infor.col = 12;
        this.row.children.splice(0, 1); //删除掉第一个列
      }
    },
    open_sys_col() {
      if (this.row.children.length == 1) {
        //生成一个空列
        this.$store.commit("app/ADD_widgets_id");
        const col = new Col({
          widgets_id: this.$store.state.app.widgets_id,
          rowType: "body",
          pid: this.row.widgets_id,
        });
        col.data.pc_infor.col = 3;
        this.row.children.unshift(col);
        this.row.children[1].data.pc_infor.col = 9;
      }
    },
    getClassList() {
      let bodyRowIndex = this.$store.state.myRender.private.banner_isShow
        ? this.row_index + 1
        : this.row_index;
      let aniClass;
      if (
        this.row.rowType === "body" &&
        !$(this.$el).parents(".material_body").length
      ) {
        aniClass = this.$store.state.app.fullPageAniClass[bodyRowIndex];
      } else if (this.row.rowType === "header") {
        aniClass = this.$store.state.app.fullPageAniClass[0];
      }
      return [
        this.isEdit ? "row_editing" : "",
        this.row.data.is_system == "true" ? "system_row" : "",
        this.row.rowType === "body" ? aniClass : "",
      ];
    },
    onClickAddRowBtn() {
      if(this.isFullPage && this.row.rowType === "body" && this.isPC) { //新增全屏通栏
          const page = [...document.querySelectorAll('#full-page-nav li')];
          if(page.length > 14) {
            this.$message.warning(i18n.t('view_left_sidebar_module_add_module_243'))
            return
          }
      }
      this.templet.add_row(this.row_index + 1, this.row);
      if (this.isFullPage && this.row.rowType === "body" && this.isPC && window.fullPage) {
        setTimeout(() => {
          window.fullPage.resetData();
          window.fullPage.resetHeight();
          if (this.row.rowType === "body") {
            // that.$store.commit('app/setFullPageCurrentIndex', index);
            window.fullPage.next();
          }
        }, 200);
      }
    },
    linear_init(key) {
      const linear_gradient = {
        start_color: "rgba(156,40,177,1)",
        end_color: "rgba(0, 0, 0,1)",
        start_pointer: 12,
        end_pointer: 100,
        deg: 90,
      }
      //通栏渐变兼容
      if (!this.row.data[key].row_background_set.default.pattern) {
        this.$set(
          this.row.data[key].row_background_set.default,
          "pattern",
          "pure_color"
        );
      }
      if (!this.row.data[key].row_background_set.custom.pattern) {
        this.$set(
          this.row.data[key].row_background_set.custom,
          "pattern",
          "pure_color"
        );
      }

      if (!this.row.data[key].row_background_set.default.linear_gradient) {
        this.$set(
          this.row.data[key].row_background_set.default,
          "linear_gradient",
          JSON.parse(JSON.stringify(linear_gradient))
        );
      }
      if (!this.row.data[key].row_background_set.custom.linear_gradient) {
        this.$set(
          this.row.data[key].row_background_set.custom,
          "linear_gradient",
          JSON.parse(JSON.stringify(linear_gradient))
        );
      }
    },
    login_register_hidden() { // 通栏隐藏
      this.$store.commit('myRender/SET_show_login_register', false)
    },
    fixFields() {
      if (!this.row.data.pc_infor.contentWidthType) {
        this.$set(this.row.data.pc_infor, "contentWidthType", 'normal');
        this.$set(this.row.data.pc_infor, "adaptBackgroundIsOpen", 'true');
      }
      if(typeof this.row.data.pc_infor.fixed_background_isOpen == 'undefined') {
        this.$set(this.row.data.pc_infor, "fixed_background_isOpen", 'false');
      }
    }
  },
  created() {
    this.fixFields()
    this.linear_init('pc_infor')
    this.linear_init('mb_infor')
  },
  mounted() {
  },
};
</script>
<style scoped lang="scss">
@import "~@/css/global-variable.scss";

.layout_row {
  .laybox_child_frame {
    position: relative;

    .vip_logo {
      position: absolute;
      right: -58px;
      top: 50%;
      width: 58px;
      transform: translate3d(0, -50%, 0);
    }
  }

  .row_edit_frame {
    left: auto !important;
    top: -50px !important;
    right: 3px;
    position: absolute;
    z-index: 1997;
    height: 50px;

    &.row_edit_center {
      left: 50% !important;
      right: auto;
      transform: translate3d(-50%, 0, 0);
    }

    &.row_edit_frame_first {
      bottom: -50px;
      top: unset !important;

      .row_edit {
        margin-top: 6px;
      }
    }

    .row_edit {
      display: flex;
      flex-direction: row;
      align-items: center;
      flex-wrap: nowrap;
      padding: 0 10px;
      height: 44px;
      line-height: 44px;
      background: #fff;
      border-radius: 5px;
      box-shadow: 0 0 5px 3px rgba(0, 0, 0, 0.1);

      .separator {
        width: 1px;
        height: 16px;
        background: #f5f5f5;
      }

      p {
        padding: 0 10px;
        cursor: pointer;
        font-size: 14px;

        &:hover {
          color: $theme-primary;
        }

        &.col {
          margin-right: 10px;
        }

        &.quit {
          margin-left: 10px;
        }
      }

      .set {
        width: 30px;
        height: 30px;
        font-size: 0;

        &:nth-of-type(1) {
          margin-left: 10px;
        }

        .close-view {
          display: inline-block;
          width: 30px;
          height: 30px;
          cursor: pointer;
          font-size: 24px;
        }

        i {
          display: inline-block;
          width: 30px;
          height: 30px;
          cursor: pointer;
          background-size: 16px 16px;
          background-position: center center;
          background-repeat: no-repeat;

          &.back {
            background-image: url("/static/image/layout-row/edit@2x.png");
            //background-position: -562px -111px;
          }

          &.add {
            background-image: url("/static/image/layout-row/add@2x.png");
            //background-position: -616px -111px;
          }

          &.after {
            background-image: url("/static/image/layout-row/up@2x.png");
            //background-position: -673px -111px;
          }

          &.before {
            background-image: url("/static/image/layout-row/down@2x.png");
            //background-position: -730px -111px;
          }

          &.close {
            background-image: url("/static/image/layout-row/delete@2x.png");
          }

          &.close_col {
            background-image: url("/static/image/layout-row/close-col@2x.png");
          }

          &.open_col {
            background-image: url("/static/image/layout-row/open-col@2x.png");
          }

          &.back:not(.disabled):hover {
            background-image: url("/static/image/layout-row/edit-blue@2x.png");
          }

          &.add:not(.disabled):hover {
            background-image: url("/static/image/layout-row/add-blue@2x.png");
          }

          &.after:not(.disabled):hover {
            background-image: url("/static/image/layout-row/up-blue@2x.png");
          }

          &.before:not(.disabled):hover {
            background-image: url("/static/image/layout-row/down-blue@2x.png");
          }

          &.close:not(.disabled):hover {
            background-image: url("/static/image/layout-row/delete-blue@2x.png");
          }

          &.close_col:not(.disabled):hover {
            background-image: url("/static/image/layout-row/close-col-blue@2x.png");
          }

          &.open_col:not(.disabled):hover {
            background-image: url("/static/image/layout-row/open-col-blue@2x.png");
          }

          &:not(.disabled):hover {
            //background-position-y: -66px;
          }

          &.disabled {
            cursor: not-allowed;
            opacity: 0.5;
          }
        }

        //hover的时候，背景图片第一次加载需要时间，不会马上显示出来，看上去会闪烁一下，用户体验不好，放在伪元素里让它预先加载一次
        i {

          &:after {
            content: '';
            position: absolute;
            width: 0;
            height: 0;
            opacity: 0;
          }

          &.back:after {
            background-image: url("/static/image/layout-row/edit-blue@2x.png");
          }

          &.add:after {
            background-image: url("/static/image/layout-row/add-blue@2x.png");
          }

          &.after:after {
            background-image: url("/static/image/layout-row/up-blue@2x.png");
          }

          &.before:after {
            background-image: url("/static/image/layout-row/down-blue@2x.png");
          }

          &.close:after {
            background-image: url("/static/image/layout-row/delete-blue@2x.png");
          }

          &.close_col:after {
            background-image: url("/static/image/layout-row/close-col-blue@2x.png");
          }

          &.open_col:after {
            background-image: url("/static/image/layout-row/open-col-blue@2x.png");
          }
        }
      }
    }
  }
}

.coverLayrow {
  width: 100%;
  height: 100%;
  position: absolute;
  left: 0;
  top: 0;
  z-index: 111;
}

.btn {
  display: none;
  position: absolute;
  left: 0;
  top: 0;
  width: 100%;
  height: 1px;
  z-index: 899;

  span {
    width: 90px;
    height: 35px;
    border-radius: 3px 3px 0 0;
    background-color: #5875d9;
    position: absolute;
    left: 50%;
    top: 0px;
    margin-top: -35px;
    margin-left: -45px;
    cursor: pointer;
    text-align: center;
    line-height: 35px;
    color: #fff;
  }

  .lineBox {
    width: 100%;
    height: 1px;
    position: absolute;
    top: -1px;
    left: 0;
    background-color: #5875d9;
  }
}

.layout_row:hover {
  .btn {
    display: block;
  }
}
</style>



// WEBPACK FOOTER //
// src/widgets/layout_row/index.vue